import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_URLS } from '../config/api.urls';

@Injectable()
export class DocumentService {
    constructor(private http: HttpClient) {}

    uploadDocument(
        file: File,
        resourceId: string,
        resource: 'PrivateSeller' | 'CompanySeller' | 'LogisticCompany' | 'LogisticAgent',
        documentType: 'Passport' | 'IdCard' | 'IdCardBack' | 'RegistrationDoc' | 'TaxComplianceCertificate' | 'RegistrationCertificate' | 'RegistrationOfIncorporation',
        deliveredAt?: string
    ): Observable<any> {
        const formData = new FormData();
        formData.append('file', file);

        const data: any = {
            resourceId: resourceId,
            resource: resource,
            documentType: documentType
        };

        // Add deliveredAt for TaxComplianceCertificate
        if (deliveredAt) {
            data.deliveredAt = deliveredAt;
        }

        const dataBlob = new Blob([JSON.stringify(data)], { type: 'application/json' });
        formData.append('data', dataBlob);

        return this.http.post(API_URLS.UPLOAD_DOCUMENT, formData);
    }

    downloadDocument(filePath: string): Observable<Blob> {
        return this.http.get(API_URLS.DOWNLOAD_DOCUMENT, {
            params: { filePath: filePath },
            responseType: 'blob'
        });
    }

    downloadDocumentById(documentId: string): Observable<Blob> {
        return this.http.get(API_URLS.DOWNLOAD_DOCUMENT, {
            params: { documentId: documentId },
            responseType: 'blob'
        });
    }

    downloadDocumentAdmin(filePath: string): Observable<Blob> {
        return this.http.get(API_URLS.ADMIN_DOWNLOAD_DOCUMENT, {
            params: { filePath: filePath },
            responseType: 'blob'
        });
    }

    downloadDocumentAdminById(documentId: string): Observable<Blob> {
        return this.http.get(API_URLS.ADMIN_DOWNLOAD_DOCUMENT, {
            params: { documentId: documentId },
            responseType: 'blob'
        });
    }

    deleteDocument(filePath: string): Observable<any> {
        return this.http.delete(API_URLS.DELETE_DOCUMENT, {
            params: { filePath: filePath }
        });
    }

    deleteDocumentById(documentId: string): Observable<any> {
        return this.http.delete(API_URLS.DELETE_DOCUMENT, {
            params: { documentId: documentId }
        });
    }
}